
import { Component, inject, input } from '@angular/core';

import { FaIconLibrary, FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { faScrewdriverWrench } from '@fortawesome/free-solid-svg-icons';

@Component({
  selector: 'app-under-development',
  templateUrl: './under-development.component.html',
  styleUrls: ['./under-development.component.scss'],
  imports: [FontAwesomeModule],
  standalone: true,
})
export class UnderDevelopmentComponent {

  readonly component = input<string>('');

  constructor() {
    const library = inject(FaIconLibrary);

    library.addIcons(
      faScrewdriverWrench,
    )
  }
}
